import { Routes, Route } from "react-router-dom"
import { URLS } from "./constants"

import Home from "./pages/Home"

export default function AppRoutes() {
  return (
    <Routes>
      <Route path={URLS.home} element={<Home />} />
    </Routes>
  )
}
